import React from 'react'
import TranslatedTextWrapper from 'components/translatedText'
import {get, isEmpty, isNil} from 'lodash'
import {featureToggleIsOn} from 'helpers/user'
import {featureToggles} from 'helpers/constants'

export const t = (text, ...tokens) => {
  return (
      <TranslatedTextWrapper dataTokens={tokens}>
        {text}
      </TranslatedTextWrapper>
  )
}

export const getDataTokensFromParams = (tokens) => {
  if (tokens.length === 0)
    return null

  const dataTokens = {}
  tokens.forEach((token, index) => {
    dataTokens[index + 1] = token
  })

  return dataTokens
}

export const shouldTranslate = (user, targetLanguage) => {
  return (
      featureToggleIsOn(user, featureToggles.MULTI_LANGUAGE) &&
      targetLanguage !== 'en'
  )
}

export const getTextNeedingTranslation = (user, textMap, languageMap, targetLanguage) => {
  return Object.values(textMap).filter(text => textNeedsTranslating(user, text, languageMap, targetLanguage))
}

export const textNeedsTranslating = (user, text, languageMap, targetLanguage) => {
  return (
      shouldTranslate(user, targetLanguage) &&
      isNil(languageMap[text])
  )
}

export const getTranslations = (user, textMap, languageMap, dataTokens, targetLanguage, showOriginal = false) => {
  const translations = {}
  Object.keys(textMap).forEach(key => {
    const text = textMap[key]
    translations[key] = getTranslation(user, text, languageMap, targetLanguage, dataTokens, showOriginal)
  })
  return translations
}

export const getTranslation = (user, text, languageMap, targetLanguage, dataTokens, showOriginal = false) => {

  const originalText = replaceDataTokens(text, dataTokens)
  const translatedText = get(languageMap, text, null)

  if (!shouldTranslate(user, targetLanguage))
    return originalText

  if (isNil(translatedText))
    return 'Translating...'

  const finalText = replaceDataTokens(translatedText, dataTokens)

  return showOriginal
      ? `${finalText} [${originalText}]`
      : finalText
}

export const replaceDataTokens = (text, dataTokens) => {
  if (isEmpty(dataTokens))
    return text

  return dataTokens.reduce((acc, value, index) => {
    return acc.replace('{' + (index + 1) + '}', value)
  }, text)
}

export const getTargetLanguages = () => {
  return [
    {value: 'ca', label: 'Catalan'},
    {value: 'yue', label: 'Cantonese (Traditional)'},
    {value: 'zh-Hans', label: 'Chinese (Simplified)'},
    {value: 'zh-Hant', label: 'Chinese (Traditional)'},
    {value: 'nl', label: 'Dutch'},
    {value: 'en', label: 'English (UK)'},
    {value: 'en-us', label: 'English (US)'},
    {value: 'fr', label: 'French'},
    {value: 'fr-CA', label: 'French (Canada)'},
    {value: 'de', label: 'German'},
    {value: 'he', label: 'Hebrew'},
    {value: 'hi', label: 'Hindi'},
    {value: 'ga', label: 'Irish'},
    {value: 'it', label: 'Italian'},
    {value: 'ja', label: 'Japanese'},
    {value: 'tlh-Latn', label: 'Klingon'},
    {value: 'pt', label: 'Portuguese (Brazil)'},
    {value: 'pt-PT', label: 'Portuguese (Portugal)'},
    {value: 'ru', label: 'Russian'},
    {value: 'es', label: 'Spanish'},
    {value: 'tr', label: 'Turkish'},
    {value: 'cy', label: 'Welsh'},
  ]
}
